module.exports = __webpack_public_path__ + "static/img/bgscimg5moxin3.ecc4a39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/bgscimg5moxin3.png
// module id = oOV5
// module chunks = 5